import React from 'react';

type Props = {
  width: number;
  height: number;
};

export const CloseIcon: React.FC<Props> = ({ width, height }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.30335 9.7886C0.717563 10.3744 0.717563 11.3241 1.30335 11.9099C1.88914 12.4957 2.83888 12.4957 3.42467 11.9099L6.60665 8.72794L9.78861 11.9099C10.3744 12.4957 11.3241 12.4957 11.9099 11.9099C12.4957 11.3241 12.4957 10.3744 11.9099 9.78858L8.72797 6.60662L11.91 3.42464C12.4957 2.83886 12.4957 1.88911 11.91 1.30332C11.3242 0.717535 10.3744 0.717536 9.78863 1.30332L6.60665 4.4853L3.42465 1.3033C2.83886 0.717514 1.88911 0.717514 1.30333 1.3033C0.717541 1.88909 0.717542 2.83883 1.30333 3.42462L4.48533 6.60662L1.30335 9.7886Z"
        fill="#61666E"
      />
    </svg>
  );
};
